// extracted by mini-css-extract-plugin
export default {"bgImage":"IndexImage_bgImage__NotyH","noImage":"IndexImage_noImage__39XoF","editButton":"IndexImage_editButton__YJloW","container":"IndexImage_container__20nCl"};